// const customForm = document.querySelector('.custom-tailor').innerHTML;
// document.addEventListener('variant:change', function(event) {
//     var variant = event.detail.variant;
//     const inputs = customForm.querySelectorAll('input, select, textarea');
//     if (variant.title.includes("CUSTOM") || variant.title.includes("Custom")) {
//         document.querySelector('.custom-tailor').innerHTML = customForm;
//         document.querySelector('.custom-tailor').style.display = 'block';
//         inputs.forEach(input => {
//           input.disabled = false;
//         });
//     }
//     else 
//     {
//         document.querySelector('.custom-tailor').innerHTML = '';
//         document.querySelector('.custom-tailor').style.display = 'none';
//         inputs.forEach(input => {
//           input.disabled = true;
//         });
//     }
// });


document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const customTailorDiv = document.querySelector('.custom-tailor');

  if (!customTailorDiv) return;

  const inputs = customTailorDiv.querySelectorAll('input, select, textarea');

  if (variant.title.includes("CUSTOM") || variant.title.includes("Custom")) {
    customTailorDiv.style.display = 'block';
    inputs.forEach(input => {
      input.disabled = false;
    });
  } else {
    customTailorDiv.style.display = 'none';
    inputs.forEach(input => {
      input.disabled = true;
    });
  }
});
